import { connect } from 'react-redux';
import { setActivePage as _setActivePage } from '../../../redux/actions/paginationActions';
import PaginationComponent from './PaginationComponent';
import config from '../../../config';
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    setActivePage: function setActivePage(activePage) {
      return dispatch(_setActivePage({
        componentName: ownProps.componentName,
        activePage: activePage
      }));
    }
  };
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activePage: state.paginationMemory[ownProps.componentName],
    maxPages: config.Pagination.maxPages
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PaginationComponent);